import { gql } from '@apollo/client';

export const ALL_ECD_REGISTRATION_TYPES = gql`
  query AllECDRegistrationTypes {
    registrationTypes: getAllEcdRegistrationTypes {
      id
      name
    }
  }
`;
